var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666687 2.65955V2.11239C0.666687 1.75876 0.807163 1.41963 1.05721 1.16958C1.30726 0.919529 1.6464 0.779053 2.00002 0.779053L20.6667 0.779053C21.0203 0.779053 21.3594 0.919529 21.6095 1.16958C21.8595 1.41963 22 1.75876 22 2.11239V2.65955L11.3334 9.32622L0.666687 2.65955ZM11.6867 10.6779C11.5807 10.744 11.4583 10.7791 11.3334 10.7791C11.2084 10.7791 11.086 10.744 10.98 10.6779L0.666687 4.23189V15.4457C0.666687 15.7993 0.807163 16.1385 1.05721 16.3885C1.30726 16.6386 1.6464 16.7791 2.00002 16.7791H20.6667C21.0203 16.7791 21.3594 16.6386 21.6095 16.3885C21.8595 16.1385 22 15.7993 22 15.4457V4.23189L11.6867 10.6779Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6f999b1aecc684c19bad7e0796c2bb71.svg";
export { ForwardRef as ReactComponent };